import React, { useContext, useRef } from "react";
import { generatePath, useHistory } from "react-router-dom";
import { Fade, Popper, makeStyles } from "@material-ui/core";
import useOutsideClick from "../../hooks/useOutsideClick";
import { ReactComponent as ArrowIcon } from "../../assets/img/order_received_arrow.svg";
import { BrandContext } from "../../context/Brand/context";
import {
  BRAND_DASHBOARD,
  BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID,
} from "../../constants";
import useAuth from "../../hooks/useAuth";

const useStyles = makeStyles(() => ({
  currentBrand: {
    cursor: "pointer",
    color: "white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
    padding: "12px 12px 12px 14px",
    borderRadius: 12,
    border: "2px solid rgba(255, 255, 255, 0.43)",
  },
  popperWrapper: {
    zIndex: 9999,
  },
  popper: {
    boxShadow: "0px 20px 30px 0px rgba(21, 23, 61, 0.07)",
    border: "1px solid rgba(75, 100, 255, 0.1)",
    borderRadius: 12,
    padding: 10,
    backgroundColor: "#fff",
    width: 213,
    maxWidth: 213,
  },
  popperItem: {
    fontSize: 14,
    padding: "10px 14px",
    cursor: "pointer",
  },
}));

const MenuBrandsPopper = ({
  actionPopperOpen,
  setActionPopperOpen,
  brands,
  currentBrand,
}) => {
  const history = useHistory();
  const actionAnchorRef = useRef();
  const classes = useStyles();
  const { brandId, isBrandRoute } = useContext(BrandContext);
  const { isBrandBudtender } = useAuth();

  const dropdownWrapperRef = useRef();
  useOutsideClick(
    dropdownWrapperRef,
    () => {
      setActionPopperOpen(false);
    },
    actionPopperOpen,
    [actionAnchorRef]
  );

  return (
    <>
      <div
        ref={actionAnchorRef}
        onClick={() => setActionPopperOpen((prevState) => !prevState)}
        className={classes.currentBrand}
      >
        <div>{currentBrand.name}</div>
        <ArrowIcon
          style={{
            transition: ".2s ease",
            transform: actionPopperOpen ? "rotate(270deg)" : "rotate(90deg)",
          }}
        />
      </div>
      <Popper
        open={actionPopperOpen}
        anchorEl={actionAnchorRef.current}
        placement="bottom-end"
        transition
        className={classes.popperWrapper}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={250}>
            <div className={classes.popper} ref={dropdownWrapperRef}>
              {brands
                .filter(({ id }) => id !== currentBrand.id)
                .map((brand) => (
                  <div
                    key={brand.id}
                    className={classes.popperItem}
                    onClick={() => {
                      const route = isBrandRoute
                        ? window.location.pathname.replace(brandId, brand.id)
                        : isBrandBudtender
                        ? generatePath(
                            BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID,
                            {
                              ordersType: "new",
                            }
                          )
                        : generatePath(BRAND_DASHBOARD, { brandId: brand.id });
                      history.push(route);
                      setActionPopperOpen(false);
                    }}
                  >
                    {brand.name}
                  </div>
                ))}
            </div>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default MenuBrandsPopper;
